import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Recipe from '../views/Recipe.vue';
import Reheat from '../views/Reheat.vue';
import RecipesData from '../data/recipes.json';

Vue.use(VueRouter);

function getRecipeProps(route) {
  let { id } = route.params;
  id -= 1;
  return {
    id: RecipesData[id].id,
    title: RecipesData[id].title,
    persons: RecipesData[id].persons,
    cookingTime: RecipesData[id].cookingTime,
    prepTime: RecipesData[id].prepTime,
    ingredients: RecipesData[id].ingredients,
    steps: RecipesData[id].steps,
  };
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/recept/:id/:title',
    component: Recipe,
    props: (route) => getRecipeProps(route),
  },
  {
    path: '/reheat',
    name: 'Reheat',
    component: Reheat,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
